module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-2e11a4c2.png";